/* ==========================================================================
   Free-shipping celebration confetti — shared burst
   --------------------------------------------------------------------------
   Exposes window.AAFreeShippingConfetti(barEl): ~90 paper particles pop up from
   the given progress bar's center in a narrow cone, arc over, and flutter down
   over 2s. No libraries, no canvas.

   Callers (both pass their own `.free-shipping-indicator` element):
   - assets/cart-free-shipping.js        — cart drawer
   - assets/aa-build-a-subscription.js   — Build A Subscription box

   The particles are appended to <body> so the burst escapes the caller's
   overflow/clip/transform ancestors, and positioned over the bar with ~90px of
   headroom above it.
   ========================================================================== */

(function () {
  if (window.AAFreeShippingConfetti) return; // the tag can be included twice

  window.AAFreeShippingConfetti = function (bar) {
    if (!bar) return;
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    var rect = bar.getBoundingClientRect();
    if (!rect.width) return;

    var container = document.createElement('div');
    container.style.cssText =
      'position:fixed;pointer-events:none;overflow:visible;z-index:10000;' +
      'left:' + rect.left + 'px;top:' + (rect.top - 90) + 'px;' +
      'width:' + rect.width + 'px;height:' + (rect.height + 90) + 'px;';
    document.body.appendChild(container);

    var COLORS = ['#8D9670', '#a9b18d', '#6f7752', '#c3c9b3', '#ffffff', '#e7e4d8', '#241f20'];
    var originX = rect.width / 2; // horizontal center of the bar
    var originY = 90 + rect.height / 2; // the bar sits 90px below the container top
    var parts = [];

    for (var i = 0; i < 90; i++) {
      var el = document.createElement('span');
      var w = 5 + Math.random() * 7; // 5–12px
      var shape = Math.floor(Math.random() * 3); // 0 square, 1 circle, 2 strip
      var h = shape === 2 ? w * 2.4 : w; // strips are 2.4× tall
      var css =
        'position:absolute;left:0;top:0;will-change:transform,opacity;width:' +
        w + 'px;height:' + h + 'px;background:' +
        COLORS[Math.floor(Math.random() * COLORS.length)] + ';';
      if (shape === 1) css += 'border-radius:50%;'; // circles
      el.style.cssText = css;
      container.appendChild(el);

      var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.35; // -90° ± 31°
      var speed = (7 + Math.random() * 8) * 0.6;
      parts.push({
        el: el,
        x: originX + (Math.random() - 0.5) * 26, // ±13px jitter
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 1.5, // extra upward kick
        rot: Math.random() * 360,
        vrot: (Math.random() - 0.5) * 22, // ±11°/frame tumble
        phase: Math.random() * Math.PI * 2
      });
    }

    var startTime = null;
    function step(now) {
      if (startTime === null) startTime = now;
      var life = Math.min((now - startTime) / 2000, 1); // 2000ms lifetime
      var fade = 1 - life; // opacity + scale 1 → 0, linear
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        p.vy += 0.22; // gravity
        if (p.vy > 3.2) p.vy = 3.2; // terminal velocity
        p.vx *= 0.985; // horizontal drag
        p.x += p.vx;
        p.y += p.vy;
        if (p.vy > 0) p.x += Math.sin(now / 160 + p.phase) * 0.8; // flutter while falling
        p.rot += p.vrot; // tumble
        p.el.style.opacity = fade;
        p.el.style.transform =
          'translate(' + p.x + 'px,' + p.y + 'px) rotate(' + p.rot + 'deg) scale(' + fade + ')';
      }
      if (life < 1) requestAnimationFrame(step);
      else container.remove(); // clean up
    }
    requestAnimationFrame(step);
  };
})();
